export type TCloudflareImageOptimizationOptions = {
  quality?: number
  width?: number
}

const STRAPI_CDN_HOST = 'https://strapi-cdn.indmoney.com'

const getCloudFlareOptimizedLink = (
  options?: TCloudflareImageOptimizationOptions,
) => {
  const { quality = 80, width } = options ?? {}

  const commaSeparatedPathNameKeyValuesMap = {
    quality,
    format: 'auto',
    metadata: 'copyright',
    width,
  }

  const allKeys = Object.keys(commaSeparatedPathNameKeyValuesMap)
  const commaSeparatedKeyValOptionsPathname = allKeys.reduce(
    (acc, key, index) => {
      const val = commaSeparatedPathNameKeyValuesMap[key]
      const isLast = index === allKeys.length - 1
      if (val) {
        acc += `${key}=${val}${isLast ? '' : ','}`
      }

      return acc
    },
    '',
  )

  return `https://strapi-cdn.indmoney.com/cdn-cgi/image/${commaSeparatedKeyValOptionsPathname}/${STRAPI_CDN_HOST}`
}

export function replaceS3SrcLinksWithCDNLinksInHTMLString(
  htmlString: string,
  options?: TCloudflareImageOptimizationOptions,
): string {
  const imgRegExp =
    /<img\b[^>]*\bsrc\s*=\s*['"]?([^'"]+\.(jpg|jpeg|png|gif|webp|avif))['"]?[^>]*>/gi
  const replacedString = htmlString.replace(imgRegExp, match => {
    return match.replace(
      /https:\/\/ind-strapi-cms\.s3\..*?\.amazonaws\.com/g,
      getCloudFlareOptimizedLink(options),
    )
  })
  return replacedString
}

export function replaceS3SrcLinkWithCDNLink(
  src: string,
  options?: TCloudflareImageOptimizationOptions,
): string {
  const imgRegExp =
    /^https:\/\/ind-strapi-cms\.s3\..*?\.amazonaws\.com\/(.+\.(jpg|jpeg|png|gif|webp|avif))$/i
  const newSrc = src.replace(
    imgRegExp,
    `${getCloudFlareOptimizedLink(options)}/$1`,
  )
  return newSrc
}

export function replaceS3SrcLinksWithCDNLinkInArticleJSONObject<
  T extends object,
>(json: T, options: TCloudflareImageOptimizationOptions = {}) {
  const retVal = JSON.parse(
    JSON.stringify(json, (key, val) => {
      if (typeof val === 'string') {
        if (key === 'richTextEditor') {
          return replaceS3SrcLinksWithCDNLinksInHTMLString(val, options)
        } else {
          return replaceS3SrcLinkWithCDNLink(val, options)
        }
      }

      return val
    }),
  )

  return retVal as T
}
